// Keep the source-selection toolbar within its own transcript viewport.
// Coordinates come from viewport-space DOMRects, never from document offsets.
export function placeTranscriptMenu(anchor,pane,menu,viewport){
  if(!anchor||!pane||!menu||!viewport)return null;
  const edge=8;
  const leftBound=Math.max(edge,pane.left+edge);
  const rightBound=Math.min(viewport.width-edge,pane.right-edge);
  const topBound=Math.max(edge,pane.top+edge);
  const bottomBound=Math.min(viewport.height-edge,pane.bottom-edge);
  const maxWidth=rightBound-leftBound,availableHeight=bottomBound-topBound;
  if(maxWidth<80||availableHeight<34)return null;
  if(anchor.bottom<topBound||anchor.top>bottomBound)return null;
  const width=Math.min(menu.width,maxWidth),height=menu.height;
  if(height>availableHeight)return null;
  const idealLeft=(anchor.left+anchor.right-width)/2;
  const left=Math.max(leftBound,Math.min(rightBound-width,idealLeft));
  const above=anchor.top-height-edge;
  const below=anchor.bottom+edge;
  const top=above>=topBound?above:below+height<=bottomBound?below:
    Math.max(topBound,Math.min(bottomBound-height,above));
  return {left,top,maxWidth};
}
